document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    const formData = new FormData(form);

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then((res) => res.json())
    .then((data) => {
      const event = new CustomEvent('product:added', { detail: data });
      document.dispatchEvent(event);
    });
  });
});
